import axios from 'axios'
import CreateEmailTemplate from './dto/CreateEmailTemplate'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedEmailTemplateResultRequestDto} from './dto/PagedEmailTemplateResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllEmailTemplates from './dto/GetAllEmailTemplates'
import UpdateEmailTemplate from './dto/UpdateEmailTemplate'
import GetEmailTemplate from './dto/GetEmailTemplate'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/EmailTemplate/Create`
export const URL_DELETE = `${API_URL}/EmailTemplate/Delete`
export const URL_GET = `${API_URL}/EmailTemplate/Get`
export const URL_GET_ALL = `${API_URL}/EmailTemplate/GetPagedAll`
export const URL_UPDATE = `${API_URL}/EmailTemplate/Update`

export function onCreateEmailTemplate(createEmailTemplate: CreateEmailTemplate): Promise<boolean> {
  return axios.post(URL_CREATE, createEmailTemplate)
}

export function onDeleteEmailTemplate(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetEmailTemplate(entityDto: EntityDto): Promise<GetEmailTemplate> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllEmailTemplates(
  pagedFilterAndSortedRequest: PagedEmailTemplateResultRequestDto
): Promise<PagedResultDto<GetAllEmailTemplates>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateEmailTemplate(
  updateEmailTemplateInput: UpdateEmailTemplate
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateEmailTemplateInput)
}
